import createLink from '@anm/helpers/createLink';

export const insertLink = (objectURL: string, fileName: string) => {
  const [link, cleanLink] = createLink(objectURL);
  link.setAttribute('download', fileName);

  return [link, cleanLink] as const;
};

const createObjectURL = (data: BlobPart, type: string) => window.URL.createObjectURL(new Blob([data], { type }));

const blobRequest = (url: string): Promise<BlobPart> =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.responseType = 'blob';
    xhr.onload = () => resolve(xhr.response as BlobPart);
    xhr.onerror = reject;

    xhr.open('GET', url, true);
    xhr.send();
  });

type DownloadProps = {
  url: string;
  type?: string;
  fileName?: string;
  onSuccess?(): void;
};

const downloadFile = async ({ url, type = 'video/mp4', fileName = 'download' }: DownloadProps) => {
  const data = await blobRequest(url);
  const objectURL = createObjectURL(data, type);
  const [link, cleanLink] = insertLink(objectURL, fileName);

  link.click();
  cleanLink();
};

export default downloadFile;
